import { render, staticRenderFns } from "./dispatchChange.vue?vue&type=template&id=d8c36120&"
import script from "./dispatchChange.vue?vue&type=script&lang=ts&"
export * from "./dispatchChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports